import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { getToken } from "../services/api";

const ProtectedRoute = () => {
  if (!getToken()) {
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
};

export default ProtectedRoute;
